import React, { useState } from 'react';
import './ContactSection.css';
import { FaEnvelope, FaSignal } from 'react-icons/fa';
import { sendContactMessage } from '../../../http/api';
import { useTranslation } from 'react-i18next';

const ContactSection = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ full_name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const handleChange = (event) => setForm({ ...form, [event.target.name]: event.target.value });
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      await sendContactMessage(form);
      setSuccess(t('contacts.success'));
      setForm({ full_name: '', email: '', message: '' });
    } catch (err) {
      alert(err?.message || t('contacts.error'));
    } finally { setLoading(false); }
  };

  return (
    <section className="wb-contact-terminal" id="sixth-div">
      <div className="wb-contact-shell">
        <aside className="wb-contact-intel">
          <span className="wb-contact-eyebrow"><i /> {t('websiteUi.directChannel')}</span>
          <h2>{t('contacts.title')}</h2>
          <p>{t('website.contactLead')}</p>
          <div className="wb-contact-channel"><span><FaSignal /></span><div><small>{t('websiteUi.responseChannel')}</small><strong>{t('website.secure')}</strong></div></div>
          <div className="wb-contact-address"><FaEnvelope /><span>contact@carrerup.com</span><FaSignal /></div>
        </aside>
        <div className="wb-contact-panel">
          <div className="wb-contact-panel-bar"><span /><span /><span /><b>{t('websiteUi.newTransmission')}</b></div>
          <form onSubmit={handleSubmit}>
            <label><span>{t('websiteUi.identity')}</span><input name="full_name" value={form.full_name} onChange={handleChange} type="text" placeholder={t('contacts.fullName')} required /></label>
            <label><span>{t('websiteUi.returnChannel')}</span><input name="email" value={form.email} onChange={handleChange} type="email" placeholder={t('contacts.email')} required /></label>
            <label><span>{t('websiteUi.yourMessage')}</span><textarea name="message" value={form.message} onChange={handleChange} placeholder={t('contacts.message')} required /></label>
            <button className="wb-contact-send" type="submit" disabled={loading}>{loading ? t('contacts.sending') : <>{t('contacts.send')} <FaSignal /></>}</button>
            {success && <div className="success-msg">{success}</div>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
